import { BaseData } from '../api/smartbestbuys-api'

export const paymentAdjustments: BaseData[] = [
  { id: 1, name: 'ส่วนลดพิเศษ' },
  { id: 2, name: 'ค่านายหน้า / ส่วนแบ่งการขาย' },
  { id: 3, name: 'ค่าดำเนินการ' },
  { id: 4, name: 'ปัดเศษ' },
  { id: 5, name: 'ลดหนี้บางส่วน' },
]
